<template>

	<div>
		<iframe :id="domId" class="ifr-content" width="100%" height="0" frameborder="0" style="overflow-y: hidden;" ></iframe>
	</div>

</template>

<script>

import $ from 'jquery'

export default {
	name: "htmlOpen",
	props: [
		'htmlCode',
		'targetId',
	],
	data() {

		let domId = "ifr-content";
		if ( this.targetId !== undefined ) {
			domId = this.targetId
		}

		return {
			domId,
		}
	},
	created() {

	},
	mounted() {

		this.init()
		// alert( doc.body.scrollHeight );

		// resize on window resize
		window.onload = () => this.frameResize();
		window.onresize = () => this.frameResize();

		/*var cssLink = document.createElement("link");
		cssLink.href = "/assets/css/app.min.css";
		cssLink.rel = "stylesheet";
		cssLink.type = "text/css";
		$frame[0].contentWindow.document.head.appendChild( cssLink )*/

	},
	updated() {

		this.frameResize();
	},
	methods: {

		async init() {

			await this.setHtml();
			this.frameResize();

			setTimeout(() => {
				this.$nextTick(() => {
					// iFrameResize({ log: true }, '#ifr-content')
					this.frameResize();
				});
			}, 500)

		},

		setHtml () {

			return new Promise((resolve) => {

				var $frame = $('#' + this.domId)
				var doc = $frame[0].contentWindow.document;

				var $body = $('body', doc);

				$body.html( this.htmlCode );

				doc.body.style.margin = 0;

				resolve();

			})

		},

		frameResize() {

			// alert( "frameResize" );
			//find the height of the internal page
			var the_height = document.querySelector('#' + this.domId).contentWindow.document.body.scrollHeight + 20;

			//change the height of the iframe
			document.querySelector('#' + this.domId).height = the_height;

			//document.getElementById('the_iframe').scrolling = "no";
			document.querySelector('#' + this.domId).style.overflowY = "hidden";


		},

	},
	watch: {

		'htmlCode': function (newVal, oldVal) {
			// console.log(oldVal)
			// console.log(newVal)
			if ( newVal !== undefined ) {
				this.init()
				this.frameResize()
			}
		}

	}
}
</script>

<style scoped>
.ifr-content {
	display: block;
	border: none;
	/*height: 100vh;*/
	/*width: 100vw;*/
}
</style>